<template>
  <section class="section-container" :style="{backgroundColor: backgroundColor || '#fff' }">
    <div class="sidebar">
      <div class="disabled" v-if="isDemo">
        <div class="disabled-text" v-if="isDemo">
          <div class="disabled-text-title bold">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="20" height="20"
                 viewBox="0 0 64 64">
              <path
                  d="M23.505,57.942c-0.497,0.322-1.048,0.483-1.655,0.483c-0.864,0-1.531-0.28-2-0.841s-0.703-1.32-0.703-2.276v-5.49h-0.8	c-2.262,0-4.161-0.4-5.697-1.2c-1.536-0.8-2.694-1.968-3.476-3.504C8.391,43.578,8,41.697,8,39.472V23.415	c0-2.225,0.391-4.106,1.172-5.642c0.782-1.536,1.94-2.704,3.476-3.504c1.536-0.8,3.435-1.2,5.697-1.2h27.395	c2.262,0,4.161,0.4,5.697,1.2c1.536,0.8,2.694,1.968,3.476,3.504c0.782,1.536,1.172,3.416,1.172,5.642v16.056	c0,2.225-0.391,4.106-1.172,5.642c-0.782,1.536-1.94,2.704-3.476,3.504c-1.536,0.8-3.435,1.2-5.697,1.2H32.774l-7.394,6.621	C24.627,57.119,24.001,57.62,23.505,57.942z M21.104,25.678h21.822c0.785,0,1.379-0.637,1.379-1.407	c0-0.772-0.597-1.379-1.379-1.379H21.104c-0.772,0-1.379,0.597-1.379,1.379C19.725,25.043,20.322,25.678,21.104,25.678z M21.104,32.713h21.822c0.785,0,1.379-0.637,1.379-1.407c0-0.773-0.597-1.407-1.379-1.407H21.104c-0.785,0-1.379,0.637-1.379,1.407	C19.725,32.078,20.322,32.713,21.104,32.713z M21.104,39.748H35.23c0.772,0,1.379-0.597,1.379-1.379	c0-0.582-0.412-1.435-1.379-1.435H21.104c-0.965,0-1.379,0.843-1.379,1.435C19.725,39.14,20.322,39.748,21.104,39.748z"></path>
            </svg>
            Demo mode
          </div>
          <div>
            You are in product tour! you need to fully signed up to access these links.
          </div>
          <div class="sep-12"></div>
          <div class="text-center">
            <button class="button is-primary" id="demo-next">
              Continue
            </button>
          </div>
        </div>
      </div>
      <a :href="homepage" class="logo"></a>
      <div class="side-menu">
        <router-link :to="{'name': 'dashboard'}" class="side-menu-item home" :class="{'active': active === 'home'}">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 24 24" xml:space="preserve">

                        <g id="Home">
                            <g id="Group-3" transform="translate(2.000000, 2.000000)">
                                <path id="Fill-2" class="st0" d="M18,18h-0.5H14v-5v-2h-2H8H6v2v5H3H2V8.5l8-6l8,6V18z M8,18h4v-5H8V18z M10,0L0,7.4V20h3h5h4h5.5
                                    H20V7.4L10,0z"/>
                            </g>
                        </g>
                    </svg>
          Home
        </router-link>
        <router-link :to="{'name': 'history'}" class="side-menu-item" :class="{'active': active === 'history'}">
          <svg version="1.1" viewBox="0 0 24 24" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px">
            <g id="History">
              <g id="Group-3" transform="translate(2.000000, 4.000000)">
                <path id="Fill-2" class="st0"
                      d="M2,14h16V8H2V14z M6,2l0.9,1.2L7.5,4h1H18v2H2V2H6z M8.5,2L7,0H0v16h20V2H8.5z"/>
              </g>
            </g>
          </svg>
          Valuations
        </router-link>
        <router-link :to="{'name': 'reports'}" class="side-menu-item report" :class="{'active': active === 'report'}">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 24 24" xml:space="preserve">
                        <g id="Reports">
                            <g id="Group" transform="translate(2.001650, 2.006250)">
                                <path id="Fill-2" class="st0" d="M18,0H2C0.9,0,0,0.9,0,2V18c0,1.1,0.9,2,2,2H18c1.1,0,2-0.9,2-2V2C20,0.9,19.1,0,18,0 M18,2
                                    C18,2,18,2,18,2l0,16c0,0,0,0,0,0H2c0,0,0,0,0,0V2c0,0,0,0,0,0H18"/>
                              <polygon id="Fill-4" class="st0" points="5,16 7,16 7,10 5,10 		"/>
                              <polygon id="Fill-6" class="st0" points="9,16 11,16 11,4 9,4 		"/>
                              <polygon id="Fill-7" class="st0" points="13,16 15,16 15,6 13,6 		"/>
                            </g>
                        </g>
                    </svg>
          Reports
        </router-link>
        <!--<router-link :to="{'name': 'fin-models'}" class="side-menu-item fin-models" :class="{'active': active === 'fin-models'}">
          <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="24px" height="24px"><path stroke-width="2%" d="M 7 2 L 7 48 L 18 48 L 18 46 L 9 46 L 9 4 L 29 4 L 29 16 L 41 16 L 41 29 L 43 29 L 43 14.585938 L 30.414062 2 L 7 2 z M 31 5.4140625 L 39.585938 14 L 31 14 L 31 5.4140625 z M 18 9 L 18 11.261719 C 16.356832 11.576386 15.145356 12.389366 14.623047 13.341797 C 13.987898 14.499991 14 15.646484 14 15.646484 C 14 17.196484 14.796514 18.406805 15.810547 19.160156 C 16.82458 19.913508 18.025391 20.340641 19.150391 20.759766 C 20.275391 21.178891 21.32458 21.591461 21.998047 22.091797 C 22.671514 22.592133 23 23.05 23 24 C 23 24 22.9935 24.724785 22.527344 25.470703 C 22.061145 26.216621 21.233333 27 19 27 C 16.833333 27 16.025274 26.06422 15.519531 25.052734 C 15.013788 24.041248 15 23 15 23 L 13 23 C 13 23 12.98621 24.458752 13.730469 25.947266 C 14.377506 27.241339 15.793165 28.528415 18 28.859375 L 18 31 L 20 31 L 20 28.771484 C 22.080752 28.48535 23.555658 27.596494 24.222656 26.529297 C 25.006457 25.275215 25 24 25 24 C 25 22.45 24.203486 21.23968 23.189453 20.486328 C 22.17542 19.732977 20.974609 19.305844 19.849609 18.886719 C 18.724609 18.467594 17.67542 18.056977 17.001953 17.556641 C 16.328486 17.056305 16 16.596484 16 15.646484 C 16 15.646484 16.0121 14.969993 16.376953 14.304688 C 16.741804 13.639381 17.303917 13 19 13 C 20.666667 13 21.224726 13.68578 21.605469 14.447266 C 21.986212 15.208752 22 16 22 16 L 24 16 C 24 16 24.01379 14.791248 23.394531 13.552734 C 22.884277 12.532226 21.665773 11.630908 20 11.285156 L 20 9 L 18 9 z M 42 31 C 39.970495 31 38.133318 31.284417 36.714844 31.791016 C 36.005606 32.044315 35.395724 32.348719 34.904297 32.763672 C 34.481505 33.120669 34.134625 33.619644 34.041016 34.210938 A 1.0001 1.0001 0 0 0 34 34.5 L 34 36.099609 C 33.769991 35.991569 33.542168 35.882806 33.285156 35.791016 C 31.866682 35.284417 30.029505 35 28 35 C 25.970495 35 24.133318 35.284417 22.714844 35.791016 C 22.005606 36.044315 21.395724 36.348719 20.904297 36.763672 C 20.481505 37.120669 20.134625 37.619644 20.041016 38.210938 A 1.0001 1.0001 0 0 0 20 38.5 L 20 46.5 C 20 47.223478 20.412853 47.821343 20.904297 48.236328 C 21.395741 48.651313 22.005599 48.955703 22.714844 49.208984 C 24.133333 49.715548 25.970518 50 28 50 C 30.029482 50 31.866667 49.715548 33.285156 49.208984 C 33.95075 48.971292 34.525191 48.685474 35 48.308594 C 35.474809 48.685474 36.04925 48.971292 36.714844 49.208984 C 38.133333 49.715548 39.970518 50 42 50 C 44.029482 50 45.866667 49.715548 47.285156 49.208984 C 47.994401 48.955703 48.604259 48.651313 49.095703 48.236328 C 49.587147 47.821343 50 47.223478 50 46.5 L 50 42.5 L 50 38.5 L 50 34.5 A 1.0001 1.0001 0 0 0 49.958984 34.203125 A 1.0001 1.0001 0 0 0 49.958984 34.201172 C 49.862985 33.614117 49.516222 33.118749 49.095703 32.763672 C 48.604276 32.348719 47.994394 32.044315 47.285156 31.791016 C 45.866682 31.284417 44.029505 31 42 31 z M 42 33 C 43.836491 33 45.498256 33.275605 46.613281 33.673828 C 47.170794 33.87294 47.587676 34.107776 47.804688 34.291016 C 48.021698 34.474255 48 34.533129 48 34.5 C 48 34.46687 48.0217 34.52575 47.804688 34.708984 C 47.587677 34.892224 47.170794 35.12706 46.613281 35.326172 C 45.498256 35.724395 43.836491 36 42 36 C 40.163509 36 38.501744 35.724395 37.386719 35.326172 C 36.829206 35.12706 36.412323 34.892224 36.195312 34.708984 C 35.978302 34.525745 36 34.466871 36 34.5 C 36 34.53313 35.9783 34.47425 36.195312 34.291016 C 36.412323 34.107776 36.829206 33.87294 37.386719 33.673828 C 38.501744 33.275605 40.163509 33 42 33 z M 36 36.900391 C 36.230009 37.008431 36.457832 37.117194 36.714844 37.208984 C 38.133318 37.715583 39.970495 38 42 38 C 44.029505 38 45.866682 37.715583 47.285156 37.208984 C 47.542168 37.117194 47.769991 37.008431 48 36.900391 L 48 38.5 C 48 38.46702 48.02168 38.52575 47.804688 38.708984 C 47.587694 38.892218 47.170787 39.127078 46.613281 39.326172 C 45.49827 39.724359 43.836518 40 42 40 C 40.163482 40 38.50173 39.724359 37.386719 39.326172 C 36.829213 39.127078 36.412306 38.892218 36.195312 38.708984 C 35.978319 38.525751 36 38.467022 36 38.5 L 36 36.900391 z M 28 37 C 29.836491 37 31.498256 37.275605 32.613281 37.673828 C 33.170794 37.87294 33.587677 38.107776 33.804688 38.291016 C 34.021698 38.474255 34 38.533129 34 38.5 C 34 38.46687 34.0217 38.52575 33.804688 38.708984 C 33.587677 38.892224 33.170794 39.12706 32.613281 39.326172 C 31.498256 39.724395 29.836491 40 28 40 C 26.163509 40 24.501744 39.724395 23.386719 39.326172 C 22.829206 39.12706 22.412323 38.892224 22.195312 38.708984 C 21.978302 38.525745 22 38.466871 22 38.5 C 22 38.53313 21.9783 38.47425 22.195312 38.291016 C 22.412323 38.107776 22.829206 37.87294 23.386719 37.673828 C 24.501744 37.275605 26.163509 37 28 37 z M 22 40.900391 C 22.230009 41.008431 22.457832 41.117194 22.714844 41.208984 C 24.133318 41.715583 25.970495 42 28 42 C 30.029505 42 31.866682 41.715583 33.285156 41.208984 C 33.542168 41.117194 33.769991 41.008431 34 40.900391 L 34 42.5 C 34 42.46702 34.02168 42.52575 33.804688 42.708984 C 33.587694 42.892218 33.170787 43.127078 32.613281 43.326172 C 31.49827 43.724359 29.836518 44 28 44 C 26.163482 44 24.50173 43.724359 23.386719 43.326172 C 22.829213 43.127078 22.412307 42.892218 22.195312 42.708984 C 21.978319 42.525751 22 42.467022 22 42.5 L 22 40.900391 z M 36 40.900391 C 36.230007 41.008428 36.457829 41.117201 36.714844 41.208984 C 38.133333 41.715548 39.970518 42 42 42 C 44.029482 42 45.866667 41.715548 47.285156 41.208984 C 47.542171 41.117201 47.769993 41.008428 48 40.900391 L 48 42.5 C 48 42.46702 48.02168 42.52575 47.804688 42.708984 C 47.587694 42.892218 47.170787 43.127078 46.613281 43.326172 C 45.49827 43.724359 43.836518 44 42 44 C 40.163482 44 38.50173 43.724359 37.386719 43.326172 C 36.829213 43.127078 36.412306 42.892218 36.195312 42.708984 C 35.978319 42.525751 36 42.467022 36 42.5 L 36 40.900391 z M 22 44.900391 C 22.230007 45.008428 22.457829 45.117201 22.714844 45.208984 C 24.133333 45.715548 25.970518 46 28 46 C 30.029482 46 31.866667 45.715548 33.285156 45.208984 C 33.542171 45.117201 33.769993 45.008428 34 44.900391 L 34 46.5 C 34 46.46702 34.02168 46.52575 33.804688 46.708984 C 33.587694 46.892218 33.170787 47.127078 32.613281 47.326172 C 31.49827 47.724359 29.836518 48 28 48 C 26.163482 48 24.50173 47.724359 23.386719 47.326172 C 22.829213 47.127078 22.412307 46.892218 22.195312 46.708984 C 21.978319 46.525751 22 46.467022 22 46.5 L 22 44.900391 z M 36 44.900391 C 36.230007 45.008428 36.457829 45.117201 36.714844 45.208984 C 38.133333 45.715548 39.970518 46 42 46 C 44.029482 46 45.866667 45.715548 47.285156 45.208984 C 47.542171 45.117201 47.769993 45.008428 48 44.900391 L 48 46.5 C 48 46.46702 48.02168 46.52575 47.804688 46.708984 C 47.587694 46.892218 47.170787 47.127078 46.613281 47.326172 C 45.49827 47.724359 43.836518 48 42 48 C 40.163482 48 38.50173 47.724359 37.386719 47.326172 C 36.829213 47.127078 36.412306 46.892218 36.195312 46.708984 C 35.978319 46.525751 36 46.467022 36 46.5 L 36 44.900391 z"/></svg>
          Financial Models
        </router-link> -->
        <router-link :to="{'name': 'shared_reports'}" class="side-menu-item share"
                     preserveAspectRatio="xMinYMin meet"
                     :class="{'active': active === 'shared_reports'}">
          <svg data-v-124580eb="" aria-hidden="true" focusable="false" data-prefix="far" data-icon="share-alt"
               role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
               class="svg-inline--fa fa-share-alt fa-w-14">
            <path data-v-124580eb="" fill="currentColor"
                  d="M352 320c-25.6 0-48.9 10-66.1 26.4l-98.3-61.5c5.9-18.8 5.9-39.1 0-57.8l98.3-61.5C303.1 182 326.4 192 352 192c53 0 96-43 96-96S405 0 352 0s-96 43-96 96c0 9.8 1.5 19.6 4.4 28.9l-98.3 61.5C144.9 170 121.6 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.6 0 48.9-10 66.1-26.4l98.3 61.5c-2.9 9.4-4.4 19.1-4.4 28.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96zm0-272c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM96 304c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm256 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                  class=""></path>
          </svg>
          Shared With Me
        </router-link>
        <router-link :to="{'name': 'account'}" class="side-menu-item account" :class="{'active': active === 'account'}">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 24 24" xml:space="preserve">
                        <g id="Account">
                            <g id="Group-7" transform="translate(2.000000, 2.000000)">
                                <g id="Group-6">
                                    <path id="Fill-2" class="st0" d="M15.6,15.7c-1.2-1.4-2.9-2.2-4.9-2.2H9.3c-1.9,0-3.7,0.9-4.9,2.2C2.9,14.3,2,12.2,2,10
                                        c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8C18,12.2,17.1,14.3,15.6,15.7 M6,16.9c0.8-0.9,2-1.4,3.3-1.4h1.4c1.3,0,2.5,0.5,3.3,1.4
                                        c-1.2,0.7-2.5,1.1-4,1.1S7.2,17.6,6,16.9 M10,0C4.5,0,0,4.5,0,10c0,2.9,1.3,5.6,3.3,7.4C5.1,19,7.4,20,10,20c2.6,0,4.9-1,6.7-2.6
                                        c2-1.8,3.3-4.5,3.3-7.4C20,4.5,15.5,0,10,0"/>
                                  <path id="Fill-4" class="st0" d="M10,9.5c-1,0-1.8-0.8-1.8-1.7C8.3,6.8,9,6,10,6s1.8,0.8,1.8,1.8C11.8,8.7,11,9.5,10,9.5 M10,4
                                        C7.9,4,6.3,5.7,6.3,7.8c0,2.1,1.7,3.7,3.8,3.7c2.1,0,3.8-1.7,3.8-3.7C13.8,5.7,12.1,4,10,4"/>
                                </g>
                            </g>
                        </g>
                    </svg>
          Account
        </router-link>
      </div>
      <div class="sep-32"></div>
      <div class="account-stats" v-if="!isDemo">
        <div class="account-state-title" v-if="!subscriptionDetails.free">
          {{ subscriptionDetails.nickname }} / {{ subscriptionDetails.interval }}
        </div>
        <div class="sep-8"></div>
        <div class="account-state-subtitle">
          {{ creditsDetails.remaining }} Credits Available
        </div>
        <div class="sep-16"></div>
        <div>
          <upgrade-action redirect-to="new-valuation">

            <button class="button is-dark" v-if="creditsDetails.remaining > 0">
              <span>
                Buy more credits
              </span>
            </button>

            <button class="button is-dark" v-if="creditsDetails.remaining === 0">

              <span>
               <i class="fa fa-plus-circle"></i> Upgrade
              </span>
            </button>
          </upgrade-action>
        </div>
      </div>
    </div>
    <div class="falcon-container">
      <div class="content">

        <nav class="level layout-toplevel" :class="[extraLevelClasses, scrollTop>30 && 'stucked']">

          <!-- Left side -->
          <div class="level-left">
            <div class="level-item main-title">
              <router-link v-if="subTitle && backPageName && !isDemo" :to="{'name': backPageName}"
                           class="layout-title-back">
                <img src="../../images/icons/chevron-back.svg" alt="">
                <span> {{ subTitle }} </span>
              </router-link>
              <div class="layout-title">
                {{ title }}
              </div>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right" v-if="!hideLogout" @click="logout()">
            <a class="button is-light">
              Log out
            </a>
          </div>

          <slot name="main-btn"></slot>
        </nav>
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {LoginAPI} from "@/apis/LoginAPI";
import UpgradeAction from "@/shared/components/UpgradeAction";
import {PaymentAPI} from "@/apis/PaymentAPI";
import Cookies from 'js-cookie'
import {config} from '@/config/config';

export default {
  name: "Layout",
  components: {
    UpgradeAction
  },
  data(){
    return {
      homepage:config('HOMEPAGE'),
      scrollTop: 0
    }
  },
  props: ['title', 'active', 'hideLogout', 'subTitle', 'backPageName', 'backgroundColor', 'isDemo', 'extraLevelClasses'],
  mounted() {

    if (window.TORef) {
      clearTimeout(window.TORef);
      clearTimeout(window.TORef2);
    }

    if (!this.isDemo) {
      if (!this.$store.state.account.creditsDetails.remaining) {
        this.$store.dispatch('account/getCredits');
        this.$store.dispatch('account/updateSubscriptionDetails');
      } else {
        window.TORef = setTimeout(() => {
          this.$store.dispatch('account/getCredits');
        }, 500);
        window.TORef2 = setTimeout(() => {
          this.$store.dispatch('account/updateSubscriptionDetails');
        }, 1000);
      }
    }

    if (!Cookies.get('payment-failed-notf') && this.subscriptionDetails.status === PaymentAPI.SUBSCRIPTION_STATUS.REQUIRES_PAYMENT_METHOD) {
      this.$router.push({name: 'payment-failed'});
      Cookies.set('payment-failed-notf', true, {expires: 20})
    }

    $(window).scroll(this.scrollHandler);
  },
  methods: {
    async logout() {
      let resp = await LoginAPI.logout();
      if (resp.success) {
        window.location.href = '/login'
        // this.$router.push({
        //     'name': 'users_login'
        // });
      }
    },
    scrollHandler(){
      this.scrollTop = $(window).scrollTop();
    }
  },
  computed: {
    subscriptionDetails() {
      return this.$store.state.account.subscriptionDetails;
    },
    creditsDetails() {
      return this.$store.state.account.creditsDetails;
    },
  },
  destroyed() {
      $(window).off("scroll", this.scrollHandler);
  },
}
</script>

<style lang="scss" scoped>
@import "../../style/vars";
@import "../../style/mixins";

.logo {
  display: block;
  outline: none;
  background-position: 17px 0px;
  background-size: 150px;
  background-repeat: no-repeat;
  background-image: url(../../images/logo_white.svg);
  height: 40px;
  margin-top: calculateRem(32px);
  margin-bottom: calculateRem(32px);
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #1C2630;
  width: 250px;
  height: 100%;
}

.content {

  /*width: calc(100% - 250px);*/
}

.layout-title {
  font-family: "Lota Grotesque Bold";
  font-size: 24px;
}

.disabled-text {
  position: absolute;
  top: 130px;
  left: 6px;
  width: calc(100% - 12px);
  z-index: 2;
  background-color: #fff;
  border-radius: 4px;

  .disabled-text-title {
    text-align: center;
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  border: none;
  padding: 10px 8px;
}

.side-menu {
  position: relative;

  .has-menu-icon {
    color: #4E5963;

    &:hover {
      svg {
        color: $primary !important;
      }
    }
  }

  .side-menu-item {
    position: relative;
    padding: 0 0 0 64px;
    background-position: 21px 7px;
    background-size: 24px;
    background-repeat: no-repeat;
    display: block;
    /*background-image: url(../../images/icons/card.svg);*/
    line-height: 48px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    font-size: 18px;
    color: #7C828A;
    svg {
      transition: 0.2s all;
      fill-rule: evenodd;
      clip-rule: evenodd;
      fill: #4E5963;
      color: #4E5963;
      position: absolute;
      top: 10px;
      left: 21px;
      width: 24px;
      height: 24px;
    }

    &:hover, &.active {
      background-color: #394450;

      svg, path {
        fill: $primary !important;
      }
    }

  }
}

.account-stats {
  border-top: 1px solid #394450;
  border-bottom: 1px solid #394450;
  padding: 17px 24px;

  .account-state-title {
    color: #FFFFFF;
    font-family: "Lota Grotesque Bold", sans-serif;
    font-size: 16px;
  }

  .account-state-subtitle {
    color: #7C828A;
    font-family: "Lota Grotesque Regular", sans-serif;
    font-size: 14px;
  }
}

.disabled {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1;
  transition: opacity 0.2s;
}

.sidebar:hover .disabled  {
  opacity: 1;
}

.main-title {
  display: block;

  .layout-title-back {
    display: flex;
    font-size: 14px;

    a {
      color: #7C828A;
      display: block;
    }

    img {
      width: 16px;
      margin-right: 6px;
      position: relative;
      top: -1px;
    }
  }
}

.level {
  &.sticky {
    position: sticky;
    top: 10px;
    z-index: 1;
    background: #fff;
    padding: 6px;
    border-radius: 4px;
    transition: all 0.2s;
  }

  &.stucked {
    box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.17);
  }
}

</style>
